export default function editFundItOptions(postData) {
  return {
    ...postData,
    success: true,
    fund: {
      ID: 99,
      name: `Signup - My Mock Fund`,
      confirmationMessage: null,
      signupPaymentsCollected: false,
    },

    fundIt: {
      hasSignupCost: true,
      cost: {
        // This is only here if costType = PerSignup
        costType: "PerSlot",
        amounts: [
          {
            numberOfSlots: null,
            amount: 10000,
          },
        ],
      },
    },
  };
}
